// @ts-nocheck
// TODO: tighten types after migration
import React, { useMemo } from "react";
import CommentsPanel from "../components/comments/CommentsPanel";
import { createBlogCommentsAdapter } from "../components/comments/adapters";
import "./BlogThoughts.css";

export default function BlogThoughts({ blogId }) {
  const [token, setToken] = React.useState(() => sessionStorage.getItem("token"));

  React.useEffect(() => {
    const handleUpdate = () => setToken(sessionStorage.getItem("token"));
    window.addEventListener("userUpdated", handleUpdate);
    return () => window.removeEventListener("userUpdated", handleUpdate);
  }, []);

  const adapter = useMemo(() => {
    if (!blogId) {
      return null;
    }
    return createBlogCommentsAdapter(blogId, token);
  }, [blogId, token]);

  if (!blogId || !adapter) {
    return null;
  }

  return (
    <CommentsPanel
      entityType="blog"
      entityId={String(blogId)}
      adapter={adapter}
      canComment={true}
      variant="blog"
    />
  );
}
